import clubRequest from "../axios";

const getReferralCode = async () =>
  (await clubRequest.merchantReferralsList()).data;
const validateReferralCode = async (referralCode: string) =>
  (
    await clubRequest.referralValidateList({
      referralCode,
    })
  ).data;
const getUserSignupByReferralCode = async () =>
  (await clubRequest.merchantReferralsList()).data;

const referralCodeService = {
  getReferralCode,
  validateReferralCode,
  getUserSignupByReferralCode,
};

export default referralCodeService;
